export const VENDOR = 'VENDOR'
export const APARTMENT = 'APARTMENT'
export const LOADING = 'LOADING'
